import React, { useState } from 'react';

type RecipientListProps = {
  label: string;
  recipients: string | string[] | undefined;
};

const RecipientList: React.FC<RecipientListProps> = ({ label, recipients }) => {
  const [expanded, setExpanded] = useState(false);

  // Handle undefined recipients
  if (!recipients) {
    return null;
  }

  // If recipients is not an array or has 5 or fewer items, just display it normally
  if (!Array.isArray(recipients) || recipients.length <= 5) {
    return (
      <div className='metadata-item'>
        <strong>{label}:</strong>{' '}
        <div className='list'>
          {Array.isArray(recipients) ? recipients.join(', ') : recipients}
        </div>
      </div>
    );
  }

  // For arrays with more than 5 recipients, implement the show more functionality
  return (
    <div className='metadata-item'>
      <strong>{label}:</strong>{' '}
      {expanded ? (
        <div className='list'>
          {recipients.join(', ')}
          <span
            className='show-more-recipients'
            onClick={() => setExpanded(false)}
          >
            Show less
          </span>
        </div>
      ) : (
        <>
          <div className='list'>
            {recipients.slice(0, 5).join(', ')}
            <span
              className='show-more-recipients'
              onClick={() => setExpanded(true)}
            >
              + {recipients.length - 5} more
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default RecipientList;
